import React from 'react';
import _ from 'lodash';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import slideLoader from '../utilities/slideLoader';
import { detectSplitView } from '../utilities/splitViewUtil';
import Tippy, { ToolTip } from './ReactTippy';
import Moment from 'moment';
import {
  WORKER_TYPES,
  API_FLAG,
  USER_ROLES,
  SCHEDULE_STATUS,
  HOT_WORKCODE,
  DATE_TIME_FORMAT,
} from '../utilities/constants';
import { isTargetRoleId } from '../utilities/roleUtility';
import { deleteControlCode } from '../utilities/stringUtil';
import { WorkOptionHistoryDropdown } from './dropdowns/single/WorkOptionHistory';
import { validateByJoi } from '../utilities/validation';
import { workBatchEditSchema } from '../utilities/validationSchemas/workRegister';

const FIXED_ITEM_COUNT = 3;
const FIXED_ITEM_MAX_LENGTH = 255;
const ITEM_MAX_LENGTH = 31;
const NAME_CREATED_BY_AUTO = '予定からの自動反映';

export default class ScrollListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: this.props.selected, //全体
      checked: this.props.checked, //個々
      isPrimeContractor: isTargetRoleId(
        [USER_ROLES.prime, USER_ROLES.branch, USER_ROLES.manager],
        LocalStorageService.getRoleId()
      ), // true: 元請ユーザー, false: 協力会社ユーザー
      validate: {
        messages: {},
      },
      formValues: {},
    };

    //フォーム用のコールバック
    this.FormProps = {
      callback: {
        submit: () => {
          console.log('Submit');
        },
      },
      //何か渡したいとき
      state: {},
    };

    this.renderColumns = this.renderColumns.bind(this);
    this.schema = workBatchEditSchema;
  }

  componentDidMount() {
    if (this.props.isBatchEdit) {
      const { data, activeFieldsEdit, fieldItem } = this.props;
      const displayFields = _.filter(
        activeFieldsEdit,
        item => fieldItem[`${item}_display_flag`] === 1
      );
      const formValues = _.fromPairs(
        _.map(displayFields, item => [item, data[item]])
      );
      formValues.id = data.id;
      this.setState({ formValues }, () => {
        this.validate('all', true);
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!this.props.isBatchEdit) {
      return true;
    }
    if (nextProps.triggerValidate !== this.props.triggerValidate) {
      this.validate('all');
    }
    return !_.isEqual(nextState, this.state);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.checked !== this.props.checked) {
      this.setState({
        selected: this.props.checked,
        checked: this.props.checked,
      });
    }
  }

  setToggleButton() {
    return !this.props.isGroupTop ? null : (
      <button
        className='btn-icon--sm'
        onClick={this.props.showLists(!this.props.show_lists)}
      >
        <i
          className={`i-warrow-${
            this.props.show_lists ? 'top' : 'bottom'
          } i-2x`}
        />
      </button>
    );
  }

  setSelectAllButton() {
    const uid = _.uniqueId();
    return !this.props.isGroupTop ? null : (
      <div className='btn-checkbox'>
        <label htmlFor={`btn-checkbox-group${this.props.data.id}-all${uid}`}>
          <input
            id={`btn-checkbox-group${this.props.data.id}-all${uid}`}
            className=''
            type='checkbox'
            checked={this.props.groupSelected}
            onClick={() => {
              this.props.onGroupSelect(!this.props.groupSelected);
            }}
          />
          <i className='i-square i-3x' />
        </label>
      </div>
    );
  }

  // 請負 or 常傭
  DayWorkerType(type) {
    switch (type) {
      case WORKER_TYPES.contractor.id:
        return WORKER_TYPES.contractor.name;
      case WORKER_TYPES.regular.id:
        return WORKER_TYPES.regular.name;
      default:
        return '';
    }
  }

  onCheck() {
    this.setState({ checked: !this.state.checked });
  }

  checked() {
    return this.state.checked;
  }

  manHoursFormat(manHours, stateHandlingFlag, isWorkSchedule) {
    if (stateHandlingFlag === API_FLAG.On) {
      return _.isNull(manHours) ? '0.0' : manHours;
    } else if (!isWorkSchedule) {
      return _.isNull(manHours) ? '未入力' : manHours;
    } else {
      // nullの場合は--に変換 nullだと何も表示できないのでクリックもできなくなる
      return _.isNull(manHours) ? '--' : manHours;
    }
  }

  /**
   * @description 小計情報整形
   * @param {string} groupManHours 小計情報
   * @param {number} stateHandlingFlag 作業中止フラグ
   */
  groupManHoursFormat(groupManHours, stateHandlingFlag) {
    if (stateHandlingFlag === API_FLAG.On) {
      return groupManHours === '--' ? '0.0' : groupManHours;
    } else {
      return groupManHours;
    }
  }

  /**
   * @description 項目の表示状態確認
   * @param {string} type 項目のtype
   */
  typeIsDisplay = type => {
    const item = SessionStorageService.isConferenceMode()
      ? _.find(this.props.workColumnsSettings.conference_order, { type })
      : _.find(this.props.workColumnsSettings.list_order, { type });
    return _.isUndefined(item) ? false : item.display === true;
  };

  setFormValues = (e, isValidate = false) => {
    const formValues = _.cloneDeep(this.state.formValues);
    formValues[e.target.name] = deleteControlCode(e.target.value);
    this.setState({ formValues }, () => {
      if (isValidate) {
        this.validate(e.target.name);
      }
    });
    this.props.setFormValues(formValues);
  };

  transformValues = (formValues, fieldItem) => {
    const result = {};
    _.map(formValues, (value, index) => {
      if (_.isObject(value)) {
        result[index] = _.isNull(value) ? '' : value;
      } else {
        result[index] = _.isNull(value) ? '' : `${value}`;
      }
    });

    const keysFormValues = _.keys(formValues);
    _.each(keysFormValues, key => {
      if (key === 'id') {
        return;
      }
      fieldItem[`${key}_display_flag`] === 1
        ? (result[`${key}_must_flag`] = fieldItem[`${key}_must_flag`] || 0)
        : (result[`${key}_must_flag`] = 0);
    });
    return result;
  };

  validate = (name = 'all', isFirstTime = false) => {
    const validate = _.cloneDeep(this.state.validate);
    const formValues = _.cloneDeep(this.state.formValues);
    const values = this.transformValues(formValues, this.props.fieldItem);
    const result = validateByJoi(this.schema, values);
    const { workColumnsSettings } = this.props;
    const item_order = workColumnsSettings.edit_multiple_order;
    if (name !== 'all') {
      if (_.has(result.messages, name)) {
        validate.messages[name] = result.messages[name];
      } else if (validate.messages[name]) {
        this.props.setCurrentErrorMessage(
          _.find(item_order, value => name === value.type).name
        );
        delete validate.messages[name];
      }
    } else if (result.messages) {
      validate.messages = result.messages;
    }
    const typeInMessage = _.filter(item_order, value =>
      Object.keys(validate.messages).includes(value.type)
    );

    if (isFirstTime) {
      if (!_.isEmpty(validate.messages)) {
        const errorFields = _.map(typeInMessage, value => value.name);
        this.props.setCurrentErrorMessage(errorFields);
      }
    } else {
      if (!_.isEmpty(validate.messages)) {
        const errorFields = _.map(typeInMessage, value => value.name);
        this.props.setErrorMessage(errorFields);
        this.props.setCurrentErrorMessage(errorFields);
      } else {
        this.props.setErrorMessage([]);
        name === 'all' && this.props.setCurrentErrorMessage([]);
      }
      this.setState({ validate });
    }
  };

  renderColumns() {
    const {
      data,
      workColumnsSettings,
      isShowReflectedWorkTotal,
      reflectedWorkTotal,
      isDisplayReflectTotalColumn,
    } = this.props;
    const isWorkSchedule =
      this.props.scheduleFlag === SCHEDULE_STATUS.schedule.id;
    const item_order = SessionStorageService.isConferenceMode()
      ? workColumnsSettings.conference_order
      : workColumnsSettings.list_order;

    const companyNameTooltip =
      data.company_name !== data.company_name_1 ? (
        <React.Fragment>
          {data.company_name_1}
          <br />({data.company_name})
        </React.Fragment>
      ) : (
        data.company_name
      );

    return _.map(item_order, item => {
      const createdUser = data.auto_reflect_flag
        ? NAME_CREATED_BY_AUTO
        : data.create_user;
      let updatedUser = data.update_user;
      if (_.isNull(data.update_user) && data.auto_reflect_flag) {
        updatedUser = NAME_CREATED_BY_AUTO;
      }
      switch (item.type) {
        case 'work_date': // 日付
          return (
            <td
              className='data-table__cell data-table__cell--minimum'
              key={item.type}
            >
              <div className='data-table__content'>
                {Moment(data.work_date).format('MM/DD')}
              </div>
            </td>
          );
        case 'approvals': // ステータス/元請会社承認
          return (
            <React.Fragment key={item.type}>
              <td
                className='data-table__cell data-table__cell--minimum'
                data-unlink
              >
                {data.auto_lock_flg === 0 ? (
                  <button
                    className={`conf-status-ticket${
                      data.approved_num > 0
                        ? ' status-ticket--large'
                        : ' status-ticket--caution--large'
                    }`}
                    onClick={this.props.onApprovalStatusClick(data.id)}
                  >
                    {data.approved_num > 0 ? '承認済' : '未承認'}(
                    {data.approved_num}/{data.should_approved_num})
                  </button>
                ) : (
                  <button
                    className={`status-ticket--autolook conf-status-ticket${
                      data.approved_num === data.should_approved_num
                        ? ' status-ticket--large'
                        : ' status-ticket--caution--large'
                    }`}
                    onClick={this.props.onApprovalStatusClick(
                      data.id,
                      data.auto_lock_flg === 1
                    )}
                  >
                    承認済(0/0)
                  </button>
                )}
              </td>
              {this.props.usePartnerCompanyApprovalFlag && (
                <td
                  className='data-table__cell data-table__cell--minimum'
                  data-unlink
                >
                  {data.partner_company_approval_flag === API_FLAG.Off ? (
                    <button
                      className='conf-status-ticket status-ticket--caution--large'
                      disabled={this.state.isPrimeContractor}
                      onClick={() =>
                        this.props.onPartnerApprovalSinglePreparation(
                          data.id,
                          true
                        )
                      }
                    >
                      {`未${this.props.partnerApprovalName}`}
                    </button>
                  ) : (
                    <button
                      className='conf-status-ticket status-ticket--large'
                      onClick={() =>
                        this.props.onPartnerApprovalSinglePreparation(
                          data.id,
                          false
                        )
                      }
                    >
                      {`${this.props.partnerApprovalName}済`}
                    </button>
                  )}
                </td>
              )}
            </React.Fragment>
          );
        case 'company_name': // 協力会社
          return (
            <td
              className='data-table__cell data-table__cell--lg data-table__cell--min-10'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{companyNameTooltip}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  {data.company_name === data.company_name_1 ? (
                    <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                      {data.company_name}
                    </span>
                  ) : (
                    <React.Fragment>
                      <span
                        className='data-table__text-wrap data-table__text-wrap--overflow'
                        style={{ WebkitLineClamp: '1' }}
                      >
                        {data.company_name_1}
                      </span>
                      <span
                        className='data-table__text-wrap data-table__text-wrap--overflow'
                        style={{ WebkitLineClamp: '1' }}
                      >
                        ({data.company_name})
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </Tippy>
            </td>
          );
        case 'job_name': // 職種
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.job_name}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.job_name}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'foreman_user_name': // 職長
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={
                  <ToolTip>
                    {data.foreman_user_name_sei
                      ? `${data.foreman_user_name_sei} ${
                          data.foreman_user_name_mei
                        }`
                      : null}
                  </ToolTip>
                }
              >
                <div className='data-table__content sys-tooltip'>
                  {data.foreman_user_name_sei ? (
                    <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                      {`${data.foreman_user_name_sei} ${
                        data.foreman_user_name_mei
                      }`}
                    </span>
                  ) : null}
                </div>
              </Tippy>
            </td>
          );
        case 'work_place': // 作業場所
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.place}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.place}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'contents': // 作業内容
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-10'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.contents}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.contents}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option1': // 項目1
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option1}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option1}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option2': // 項目2
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option2}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option2}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option3': // 項目3 (他職への注意事項)
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option3}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option3}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'manager_user_name': // 元請担当
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              style={{ paddingRight: '5px' }}
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={
                  <ToolTip>
                    {data.manager_user_name_sei
                      ? `${data.manager_user_name_sei} ${
                          data.manager_user_name_mei
                        }`
                      : null}
                  </ToolTip>
                }
              >
                <div className='data-table__content sys-tooltip'>
                  {data.manager_user_name_sei ? (
                    <span className='data-table__text-wrap-line'>
                      {`${data.manager_user_name_sei} ${
                        data.manager_user_name_mei
                      }`}
                    </span>
                  ) : null}
                </div>
              </Tippy>
            </td>
          );
        case 'dayworker_type': // 契約 請負 or 常傭
          return (
            <td className='data-table__cell' key={item.type}>
              <div className='data-table__content'>
                <span className='data-table__text-wrap-line'>
                  {this.DayWorkerType(data.dayworker_type)}
                </span>
              </div>
            </td>
          );
        case 'early_over_time': // 早残
          return (
            <td
              className='data-table__cell'
              style={{ paddingRight: '10px' }}
              key={item.type}
            >
              <div className='data-table__content' style={{ maxWidth: '50px' }}>
                {data.is_early_time !== API_FLAG.On ? null : (
                  <div className='box-info_noline' key='hayade'>
                    早出
                  </div>
                )}
                {data.is_over_time !== API_FLAG.On ? null : (
                  <div className='box-info_noline' key='zangyo'>
                    残業
                  </div>
                )}
              </div>
            </td>
          );
        case 'man_hours': // 人工
          return (
            <React.Fragment>
              <td
                className='data-table__cell data-table__cell--minimum'
                data-unlink
                key={item.type}
              >
                <div className='data-table__content sys-modal-open-jinkou-input'>
                  <div className='sys-modal-open-jinkou-input__item'>
                    <div className='box-info_noline' key='hayade'>
                      人工
                    </div>
                    {isWorkSchedule ? null : (
                      <React.Fragment>
                        <span>{data.schedule_man_hours}</span> /{' '}
                      </React.Fragment>
                    )}
                    <span
                      className={
                        data.state_handling_flag === API_FLAG.Off
                          ? `clickable-text${
                              _.isNull(data.man_hours) ? '--negative' : ''
                            }`
                          : ''
                      }
                      onClick={() => {
                        if (data.state_handling_flag === API_FLAG.Off) {
                          _.isFunction(this.props.onManHourEditClick) &&
                            this.props.onManHourEditClick();
                        }
                      }}
                    >
                      {this.manHoursFormat(
                        data.man_hours,
                        data.state_handling_flag,
                        isWorkSchedule
                      )}
                    </span>
                  </div>
                  <div className='sys-modal-open-jinkou-input__item'>
                    {!this.props.isGroupTop ? null : (
                      <React.Fragment>
                        <div className='box-info_noline' key='hayade'>
                          小計
                        </div>
                        <span>
                          {this.groupManHoursFormat(
                            this.props.groupManHours,
                            data.state_handling_flag
                          )}
                        </span>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </td>
              {isDisplayReflectTotalColumn && (
                <td className='data-table__cell' key='man_hour_actual'>
                  <div className='data-table__content'>
                    <span className='data-table__text-wrap-line'>
                      {isShowReflectedWorkTotal
                        ? `${_.defaultTo(reflectedWorkTotal, 0)}人`
                        : ''}
                    </span>
                  </div>
                </td>
              )}
            </React.Fragment>
          );
        case 'woman_non_japanese_count': // 女性人数・外国人数
          return (
            <React.Fragment key={item.type}>
              <td className='data-table__cell data-table__cell--md'>
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    女性：{data.woman}人
                  </span>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    外国：{data.non_japanese}人
                  </span>
                </div>
              </td>
            </React.Fragment>
          );
        case 'option4': //
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option4}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option4}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option5': //
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option5}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option5}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option6': //
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option6}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option6}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'memo': // 指示書備考欄
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.memo}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.memo}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'hot_work': // 火気
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <div className='data-table__content sys-tooltip'>
                <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                  {_.result(
                    _.find(HOT_WORKCODE, { id: data.hot_work_code }),
                    'name'
                  )}
                  <br />
                  {!_.isNull(data.hot_work_start) &&
                    !_.isNull(data.hot_work_end) && (
                      <span>
                        {Moment(data.hot_work_start, 'HH:mm:ss').format(
                          'HH:mm'
                        )}
                        &ndash;
                        {Moment(data.hot_work_end, 'HH:mm:ss').format('HH:mm')}
                      </span>
                    )}
                </span>
              </div>
            </td>
          );
        case 'oxygen_lack': // 酸欠
          return (
            <td
              className='data-table__cell data-table__cell--min-10'
              key={item.type}
            >
              <div className='data-table__content sys-tooltip'>
                <div className='data-table__labelled-line'>
                  <span className='data-table__label'>危険作業主任者</span>
                  {!_.isEmpty(data.oxygen_lack_dangerous_work_upper) && (
                    <span>1:{data.oxygen_lack_dangerous_work_upper}</span>
                  )}
                  {!_.isEmpty(data.oxygen_lack_dangerous_work_upper) &&
                    !_.isEmpty(data.oxygen_lack_dangerous_work_lower) && (
                      <span style={{ margin: '0 8px' }}>&#47;</span>
                    )}
                  {!_.isEmpty(data.oxygen_lack_dangerous_work_lower) && (
                    <span>2:{data.oxygen_lack_dangerous_work_lower}</span>
                  )}
                </div>
                <div className='data-table__labelled-line'>
                  <span className='data-table__label'>特別教育修了者</span>
                  {!_.isEmpty(data.oxygen_lack_education_complete_upper) && (
                    <span>1:{data.oxygen_lack_education_complete_upper}</span>
                  )}
                  {!_.isEmpty(data.oxygen_lack_education_complete_upper) &&
                    !_.isEmpty(data.oxygen_lack_education_complete_lower) && (
                      <span style={{ margin: '0 8px' }}>&#47;</span>
                    )}
                  {!_.isEmpty(data.oxygen_lack_education_complete_lower) && (
                    <span>2:{data.oxygen_lack_education_complete_lower}</span>
                  )}
                </div>
              </div>
            </td>
          );
        case 'key_plan_name': // 作業安全指示書用画像（キープラン）名
          return (
            <td
              className='data-table__cell data-table__cell--sm'
              key={item.type}
            >
              <div className='data-table__content sys-tooltip'>
                <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                  {data.key_plan_name}
                </span>
              </div>
            </td>
          );
        case 'print_groups': // 印刷グループ
          return (
            <td
              className='data-table__cell data-table__cell--sm'
              key={item.type}
            >
              <div className='data-table__content sys-tooltip'>
                <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                  {data.print_groups}
                </span>
              </div>
            </td>
          );
        case 'option7':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option7}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option7}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option8':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option8}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option8}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option9':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option9}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option9}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option10':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option10}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option10}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option11':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option11}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option11}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option12':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option12}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option12}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option13':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option13}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option13}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option14':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option14}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option14}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option15':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option15}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option15}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option16':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option16}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option16}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option17':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option17}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option17}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option18':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option18}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option18}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option19':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option19}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option19}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option20':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.option20}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.option20}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'work_create_user':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{createdUser}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {createdUser}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'work_created_at':
          return (
            <td
              className='data-table__cell data-table__cell--lg data-table__cell--min-10'
              key={item.type}
            >
              <div className='data-table__content sys-tooltip'>
                <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                  {Moment(data.created_at).format(
                    DATE_TIME_FORMAT.slashDateTimeFormat
                  )}
                </span>
              </div>
            </td>
          );
        case 'work_update_user':
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{updatedUser}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {updatedUser}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'work_updated_at':
          return (
            <td
              className='data-table__cell data-table__cell--lg data-table__cell--min-10'
              key={item.type}
            >
              <div className='data-table__content sys-tooltip'>
                <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                  {Moment(data.updated_at).format(
                    DATE_TIME_FORMAT.slashDateTimeFormat
                  )}
                </span>
              </div>
            </td>
          );
        default:
          // console.error(`${item.name}表示エラー`);
          return <td />; // Error, 何も表示しない
      }
    });
  }

  renderItemOption = item => {
    const { fieldItem, data } = this.props;
    const { formValues } = this.state;

    if (!fieldItem || item - FIXED_ITEM_COUNT > fieldItem.create_item_count) {
      return null;
    }

    return (
      <td
        className={`data-table__cell data-table__cell--min-8 data-table__form-edit 
        ${
          _.has(this.state.validate.messages, [`option${item}`])
            ? 'data-table__form-edit--error'
            : ''
        }`}
        key={item.type}
      >
        <div className='data-table__content sys-tooltip'>
          {fieldItem[`option${item}_history_flag`] ? (
            <WorkOptionHistoryDropdown
              value={formValues[`option${item}`]}
              fieldTreeId={data.field_tree_id}
              jobId={data.job_id}
              foremanUserId={data.foreman_user_id}
              resetKeys={[
                data.field_tree_id,
                data.job_id,
                data.foreman_user_id,
              ]}
              column={`option${item}`}
              set={(name, value, isValidate) =>
                this.setFormValues({ target: { name, value } }, isValidate)
              }
              validate={this.validate}
              maxLength={
                item <= FIXED_ITEM_COUNT
                  ? FIXED_ITEM_MAX_LENGTH
                  : ITEM_MAX_LENGTH
              }
              editTableError={_.get(
                this.state.validate,
                `messages.option${item}`,
                ''
              )}
              inputClassName='data-table__content__input data-table__content__input--history-button'
              validationClassname='data-table__validation data-table__validation__history'
            />
          ) : (
            <div className='data-table__content__edit-table'>
              <input
                className='data-table__content__input'
                type='text'
                maxLength={
                  item <= FIXED_ITEM_COUNT
                    ? FIXED_ITEM_MAX_LENGTH
                    : ITEM_MAX_LENGTH
                }
                name={`option${item}`}
                value={formValues[`option${item}`]}
                onChange={this.setFormValues}
                onBlur={e => this.validate(e.target.name)}
              />
              <div className='data-table__validation'>
                {_.get(this.state.validate, `messages.option${item}`, '')}
              </div>
            </div>
          )}
        </div>
      </td>
    );
  };

  renderColumnMultiEdit = () => {
    const { data, workColumnsSettings, fieldItem } = this.props;
    const fixedItems = [
      'work_date',
      'company_name',
      'job_name',
      'work_place',
      'contents',
    ];
    const items = _.filter(
      workColumnsSettings.edit_multiple_order,
      item =>
        fixedItems.includes(item.type) ||
        (fieldItem[`${item.type}_display_flag`] === 1 && item.display)
    );

    const companyNameTooltip =
      data.company_name !== data.company_name_1 ? (
        <React.Fragment>
          {data.company_name_1}
          <br />({data.company_name})
        </React.Fragment>
      ) : (
        data.company_name
      );

    return _.map(items, item => {
      switch (item.type) {
        case 'work_date': // 日付
          return (
            <td
              className='data-table__cell data-table__cell--min-8 data-table__cell--small'
              key={item.type}
            >
              <div className='data-table__content'>
                {Moment(data.work_date).format('MM/DD')}
              </div>
            </td>
          );
        case 'company_name': // 協力会社
          return (
            <td
              className='data-table__cell data-table__cell--lg data-table__cell--min-8 data-table__cell--large'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{companyNameTooltip}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  {data.company_name === data.company_name_1 ? (
                    <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                      {data.company_name}
                    </span>
                  ) : (
                    <React.Fragment>
                      <span className='data-table__text-wrap data-table__text-wrap--overflow data-table__text-wrap--line-clamp'>
                        {data.company_name_1}
                      </span>
                      <span className='data-table__text-wrap data-table__text-wrap--overflow data-table__text-wrap--line-clamp'>
                        ({data.company_name})
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </Tippy>
            </td>
          );
        case 'job_name': // 職種
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8 data-table__cell--large'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.job_name}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.job_name}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'work_place': // 作業場所
          return (
            <td
              className='data-table__cell data-table__cell--md data-table__cell--min-8 data-table__cell--large'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.place}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.place}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'contents': // 作業内容
          return (
            <td
              className='data-table__cell data-table__cell--min-8 data-table__cell--large'
              key={item.type}
            >
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={<ToolTip>{data.contents}</ToolTip>}
              >
                <div className='data-table__content sys-tooltip'>
                  <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                    {data.contents}
                  </span>
                </div>
              </Tippy>
            </td>
          );
        case 'option1':
          return this.renderItemOption(1);
        case 'option2':
          return this.renderItemOption(2);
        case 'option3':
          return this.renderItemOption(3);
        case 'option4':
          return this.renderItemOption(4);
        case 'option5':
          return this.renderItemOption(5);
        case 'option6':
          return this.renderItemOption(6);
        case 'option7':
          return this.renderItemOption(7);
        case 'option8':
          return this.renderItemOption(8);
        case 'option9':
          return this.renderItemOption(9);
        case 'option10':
          return this.renderItemOption(10);
        case 'option11':
          return this.renderItemOption(11);
        case 'option12':
          return this.renderItemOption(12);
        case 'option13':
          return this.renderItemOption(13);
        case 'option14':
          return this.renderItemOption(14);
        case 'option15':
          return this.renderItemOption(15);
        case 'option16':
          return this.renderItemOption(16);
        case 'option17':
          return this.renderItemOption(17);
        case 'option18':
          return this.renderItemOption(18);
        case 'option19':
          return this.renderItemOption(19);
        case 'option20':
          return this.renderItemOption(20);
        default:
          return null;
      }
    });
  };

  render() {
    const { data, isBatchEdit, unapprovedFlag } = this.props;

    const uniqueId = _.uniqueId();

    const workSuspendStyle = {
      background: '#7C7C7C',
    };

    const isWorkSchedule =
      this.props.scheduleFlag === SCHEDULE_STATUS.schedule.id;
    const isDisableCheckbox =
      !isWorkSchedule && _.isNull(data.man_hours) && unapprovedFlag;

    return (
      <tr
        className='data-table__item data-table__item--pointer'
        onClick={e => {
          if (isBatchEdit) {
            return;
          }
          //どちらのビューにいるかを取得
          this.FormProps.state.id = this.props.data.id;
          if (e.target.closest('[data-unlink]')) {
            return;
          }
          let page = isWorkSchedule ? 'WorkScheduleEdit' : 'WorkResultEdit';
          if (unapprovedFlag) {
            page = isWorkSchedule
              ? 'WorkScheduleUnapprovedEdit'
              : 'WorkResultUnapprovedEdit';
          }
          slideLoader.show(page, this.FormProps, detectSplitView(e));
        }}
        style={data.state_handling_flag === API_FLAG.On ? workSuspendStyle : {}}
      >
        {isBatchEdit ? (
          <td className='data-table__cell data-table__cell--min-8 data-table__cell--small'>
            <div className='data-table__content sys-tooltip'>
              <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                {`00${this.props.index + 1}`.slice(-3)}
              </span>
            </div>
          </td>
        ) : (
          // 開閉
          <td
            className='data-table__cell data-table__cell--fix-minimum'
            data-unlink
            style={{ paddingRight: '5px' }}
          >
            {this.setToggleButton()}
          </td>
        )}

        {SessionStorageService.isConferenceMode() || isBatchEdit ? null : (
          <React.Fragment>
            <td
              className='data-table__cell data-table__cell--fix-minimum'
              data-unlink
            >
              {/* チェックボックス */}
              {this.setSelectAllButton()}

              <div className='btn-checkbox'>
                <label
                  htmlFor={`btn-checkbox-group${this.props.data.id}-${
                    this.props.index
                  }${uniqueId}`}
                >
                  <input
                    id={`btn-checkbox-group${this.props.data.id}-${
                      this.props.index
                    }${uniqueId}`}
                    className='sys-btn-checkbox'
                    type='checkbox'
                    checked={this.props.checked}
                    disabled={isDisableCheckbox}
                    onClick={() => {
                      this.props.onWorkSelect();
                    }}
                  />
                  <i
                    className={`i-square i-3x ${isDisableCheckbox ? 'btn-checkbox--disabled' : ''}`}
                  />
                </label>
              </div>
            </td>
          </React.Fragment>
        )}
        {isBatchEdit ? this.renderColumnMultiEdit() : this.renderColumns()}
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ScrollListItem.jsx